var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Compiler, Component, Inject, Injector, Input, } from '@angular/core';
import { LayoutReadingService, ModuleRegistryService, PageLayoutModel, pageModuleRegistryKey, } from '@synisys/idm-dynamic-layout-interpreter';
import { BasePageService, } from '@synisys/idm-page-service-client-js';
import { CurrentLanguageProvider } from '@synisys/idm-session-data-provider-api-js';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute } from '@angular/router';
import { mergeMap, takeUntil } from 'rxjs/operators';
import { DynamicLayout, DynamicLayoutType } from '../dynamic-layout';
import './page.component.scss';
import { noop } from "rxjs/util/noop";
var DynamicPageComponent = /** @class */ (function (_super) {
    __extends(DynamicPageComponent, _super);
    function DynamicPageComponent(injector, compiler, pageService, layoutReadingService, activatedRouter, currentLanguageProvider, moduleRegistryService) {
        var _this = _super.call(this) || this;
        _this.injector = injector;
        _this.compiler = compiler;
        _this.pageService = pageService;
        _this.layoutReadingService = layoutReadingService;
        _this.activatedRouter = activatedRouter;
        _this.currentLanguageProvider = currentLanguageProvider;
        _this.moduleRegistryService = moduleRegistryService;
        _this.isReady = false;
        return _this;
    }
    Object.defineProperty(DynamicPageComponent.prototype, "thisRef", {
        get: function () {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    DynamicPageComponent.prototype.ngOnInit = function () {
        this.filters = this.activatedRouter.snapshot.queryParams['filters'];
    };
    DynamicPageComponent.prototype.ngOnChanges = function (changes) {
        if (changes['pageId'] || changes['pageName']) {
            this.initPage();
        }
    };
    DynamicPageComponent.prototype.ngOnDestroy = function () {
        if (this._runtimeRef) {
            this._runtimeRef.destroy();
        }
        _super.prototype.ngOnDestroy.call(this);
    };
    DynamicPageComponent.prototype.addRuntimeComponent = function (controlModel, moduleType, component) {
        var layout = this;
        this._moduleSet.add(moduleType);
        /* tslint:disable:max-classes-per-file*/
        var cmpClass = /** @class */ (function () {
            function RuntimeComponent() {
                this.form = layout;
                this.cellId = controlModel.id;
                this.controlId = controlModel.id;
                this.hasPublishingAccess = layout.hasPublishingAccess;
            }
            Object.defineProperty(RuntimeComponent.prototype, "filters", {
                get: function () {
                    return layout.activatedRouter.snapshot.queryParams['filters'];
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RuntimeComponent.prototype, "currentLanguageId", {
                get: function () {
                    return layout.currentLanguage.getId();
                },
                enumerable: true,
                configurable: true
            });
            return RuntimeComponent;
        }());
        /* tslint:enable:max-classes-per-file*/
        Component(component)(cmpClass);
        this._componentCache.set(controlModel.id, cmpClass);
        if (this._componentCache.size === this._countOfControls) {
            this.loadRuntimeModule().subscribe(noop, console.error);
        }
    };
    DynamicPageComponent.prototype.getActionNotifier = function () {
        return undefined;
    };
    DynamicPageComponent.prototype.getInitialTabId = function () {
        return 0;
    };
    DynamicPageComponent.prototype.getLayoutActions = function () {
        return undefined;
    };
    DynamicPageComponent.prototype.getMetaForm = function () {
        return undefined;
    };
    DynamicPageComponent.prototype.getPredicateContext = function () {
        return undefined;
    };
    DynamicPageComponent.prototype.getCurrentLanguage = function () {
        return this.currentLanguage;
    };
    DynamicPageComponent.prototype.isForm = function () {
        return false;
    };
    DynamicPageComponent.prototype.getEntity = function () {
        return undefined;
    };
    DynamicPageComponent.prototype.isSubForm = function () {
        return false;
    };
    DynamicPageComponent.prototype.dynamicLayoutType = function () {
        return DynamicLayoutType.subForm;
    };
    DynamicPageComponent.prototype.getModuleRegistryService = function () {
        return this.moduleRegistryService;
    };
    DynamicPageComponent.prototype.getValidations = function () {
        return undefined;
    };
    DynamicPageComponent.prototype.countNumberOfControls = function () {
        return this.countControlsOfGrid(this.layout.content);
    };
    DynamicPageComponent.prototype.countControlsOfGrid = function (grid) {
        var sum = 0;
        if (grid) {
            for (var _i = 0, _a = grid.rows; _i < _a.length; _i++) {
                var row = _a[_i];
                for (var _b = 0, _c = row.cells; _b < _c.length; _b++) {
                    var cell = _c[_b];
                    if (cell.controlModel) {
                        sum += 1;
                    }
                    else if (cell.grid) {
                        sum += this.countControlsOfGrid(cell.grid);
                    }
                }
            }
        }
        return sum;
    };
    DynamicPageComponent.prototype.initPage = function () {
        var _this = this;
        this._moduleSet = new Set();
        this._componentCache = new Map();
        this.currentLanguageProvider
            .getCurrentLanguage()
            .pipe(takeUntil(this.destroySubject$))
            .subscribe(function (language) {
            _this.currentLanguage = language;
        }, console.error);
        var pageModel$ = this.pageId && this.pageId > 0
            ? this.pageService.getPageStructure(this.pageId)
            : this.pageService.getPageStructure(0, this.pageName);
        pageModel$
            .pipe(mergeMap(function (pageDto) {
            var layoutJson = pageDto.getLayout();
            if (layoutJson !== null && layoutJson !== '') {
                return _this.layoutReadingService.readPage(pageDto.getLayout(), _this.pageName);
            }
            else {
                return Observable.of(new PageLayoutModel(_this.pageName, undefined));
            }
        }), takeUntil(this.destroySubject$))
            .subscribe(function (layoutModel) {
            _this.layout = layoutModel;
            _this._countOfControls = _this.countNumberOfControls();
            _this.isReady = true;
        }, function (error) {
            console.error(error);
        });
    };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DynamicPageComponent.prototype, "pageName", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], DynamicPageComponent.prototype, "pageId", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DynamicPageComponent.prototype, "hasPublishingAccess", void 0);
    DynamicPageComponent = __decorate([
        Component({
            moduleId: module.id + '',
            selector: 'dynamic-page',
            template: require('./page.component.html'),
        }),
        __param(6, Inject(pageModuleRegistryKey)),
        __metadata("design:paramtypes", [Injector,
            Compiler,
            BasePageService,
            LayoutReadingService,
            ActivatedRoute,
            CurrentLanguageProvider,
            ModuleRegistryService])
    ], DynamicPageComponent);
    return DynamicPageComponent;
}(DynamicLayout));
export { DynamicPageComponent };
//# sourceMappingURL=page.component.js.map